import React, { useEffect, useState } from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer";
import homebanner from "../assets/home-banner.png";
import Adbanner from "../assets/ad-poster-kalams.png";
import { AiOutlineHeart, AiFillHeart, AiOutlineEye, AiOutlineSearch } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";

const formatNumber = (num) => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.toString();
};

function Home() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showAllPersonal, setShowAllPersonal] = useState(false);
  const [showAllProfessional, setShowAllProfessional] = useState(false);

  useEffect(() => {
    fetch("/php-api/get-profile.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setProfiles(data.data);
        } else {
          setProfiles([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleLike = async (id) => {
    const likeKey = `liked_${id}`;
    const hasLiked = localStorage.getItem(likeKey);

    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("action", hasLiked ? "unlike" : "like");

      const res = await axios.post(
        "/php-api/like-profile.php",
        formData
      );

      if (res.data.success) {
        setProfiles((prev) =>
          prev.map((p) =>
            p.id === id
              ? {
                  ...p,
                  like: hasLiked
                    ? Math.max(Number(p.like || 1) - 1, 0)
                    : Number(p.like || 0) + 1,
                }
              : p
          )
        );
        if (hasLiked) {
          localStorage.removeItem(likeKey);
        } else {
          localStorage.setItem(likeKey, "true");
        }
      } else {
        alert(res.data.message || "Failed to update like");
      }
    } catch (err) {
      console.error("Like error:", err);
      alert("Something went wrong");
    }
  };

  const filteredProfiles = profiles.filter((profile) => {
    const search = searchTerm.toLowerCase();
    return (
      profile.name?.toLowerCase().includes(search) ||
      profile.nickname?.toLowerCase().includes(search) ||
      profile.profession?.toLowerCase().includes(search) ||
      profile.eduqualification?.toLowerCase().includes(search) ||
      profile.message?.toLowerCase().includes(search) ||
      profile.school?.toLowerCase().includes(search) ||
      profile.hobbies?.toLowerCase().includes(search) ||
      profile.dob?.toLowerCase().includes(search)
    );
  });

  const personalProfiles = filteredProfiles
    .filter((p) => p.profile === "personal")
    .slice(0, showAllPersonal ? filteredProfiles.length : 3);

  const professionalProfiles = filteredProfiles
    .filter((p) => p.profile === "professional")
    .slice(0, showAllProfessional ? filteredProfiles.length : 3);

  return (
    <div>
      <Header />

      <div className="page-body-container">

        {/* Banner */}
        <div className="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32 home-banner-responsive">
          <img
            src={homebanner}
            alt="Banner"
            className="absolute inset-0 -z-10 w-full h-full object-cover object-center"
          />
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <h2 className="text-lg md:text-2xl font-medium tracking-tight text-white">
              Giffypedia – The People’s Encyclopedia. <br></br>Discover real stories of achievers, celebrities & influencers, all in one place
            </h2>
            <form className="max-w-md mx-auto mt-10" onSubmit={(e) => e.preventDefault()}>
              <div className="relative">
                <AiOutlineSearch className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-400 text-lg" />
                <input
                  type="search"
                  className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Search Profile"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
            </form>
          </div>
        </div>
        {/* Responsive banner height */}
        <style>
          {`
            @media (max-width: 1024px) {
              .home-banner-responsive {
                padding-top: 48px !important;
                padding-bottom: 48px !important;
              }
            }
            @media (max-width: 640px) {
              .home-banner-responsive {
                padding-top: 28px !important;
                padding-bottom: 28px !important;
              }
            }
          `}
        </style>

        {loading && (
          <div className="loading-container" style={{ textAlign: 'center', margin: '3rem 0' }}>
            <div className="spinner"></div>
          </div>
        )}

        {/* No profiles found message */}
        {!loading && filteredProfiles.length === 0 && (
          <div
            className="no-profiles-found"
            style={{ textAlign: 'center', margin: '3rem 0', fontSize: '1.25rem', color: '#666' }}
          >
            No profile found
          </div>
        )}

        {/* Individual Biography */}
        {!loading && personalProfiles.length > 0 && (
          <div className="profile-card-row">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold text-gray-800">Individual Biography</h2>
              {filteredProfiles.filter((p) => p.profile === "personal").length > 3 && (
                <button onClick={() => setShowAllPersonal(!showAllPersonal)} className="text-sm text-blue-600 hover:underline">
                  {showAllPersonal ? "Show less" : "View all →"}
                </button>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {personalProfiles.map((profile) => (
                <div key={profile.id} className="profile-list-card">
                  <div className="profileimg">
                    <img
                      src={`https://www.giffypedia.com/uploads/${profile.avatar || 'default.jpg'}`}
                      alt={profile.name}
                      className="profile-image"
                    />
                  </div>
                  <div className="p-3 relative">
                    <h3 className="text-lg font-bold text-overflow flex items-center gap-2 max-sm:justify-center">
                      {profile.name}
                      <img
                        src={`https://www.giffypedia.com/uploads/${profile.verified || 'not-verified.jpg'}`}
                        alt={profile.name}
                        className="profile-image ml-1 inline-block"
                      />
                    </h3>
                    <p className="text-sm text-gray-500 text-overflow max-sm:justify-center">{profile.profession}</p>
                    <p className="text-sm text-gray-600 mt-2 line-clamp-3">{profile.message}</p>
                    <div className="profile-action space-x-3">

                      <button onClick={() => handleLike(profile.id)} className="flex items-center space-x-1 text-red-600 font-semibold">
                        {localStorage.getItem(`liked_${profile.id}`) ? (
                          <AiFillHeart className="text-xl" />
                        ) : (
                          <AiOutlineHeart className="text-xl" />
                        )}
                        <span>{formatNumber(profile.like)}</span>
                      </button>

                      <span className="flex items-center gap-1"><AiOutlineEye /> {formatNumber(profile.view)} Views</span>
                      <Link
                        to={`/profile/${profile.name.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}-${profile.id}`}
                        className="text-blue-600 hover:underline"
                      >
                        View Profile
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Professional Profiles */}
        {!loading && professionalProfiles.length > 0 && (
          <div className="profile-card-row">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold text-gray-800">Professional Profiles</h2>
              {filteredProfiles.filter((p) => p.profile === "professional").length > 3 && (
                <button
                  onClick={() => setShowAllProfessional(!showAllProfessional)}
                  className="text-sm text-blue-600 hover:underline"
                >
                  {showAllProfessional ? "Show less" : "View all →"}
                </button>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {professionalProfiles.map((profile) => (
                <div key={profile.id} className="profile-list-card">
                  <div className="profileimg">
                    <img
                      src={`https://www.giffypedia.com/uploads/${profile.avatar || 'default.jpg'}`}
                      alt={profile.companyname || 'Business'}
                      className="profile-image"
                    />
                  </div>
                  <div className="p-3 relative">
                    <h3 className="text-lg font-bold text-overflow flex items-center gap-2 max-sm:justify-center">
                      {profile.companyname || "NA"}
                      <img
                        src={`https://www.giffypedia.com/uploads/${profile.verified || 'not-verified.jpg'}`}
                        alt={profile.name}
                        className="profile-image ml-1 inline-block"
                      />
                    </h3>
                    <p className="text-sm text-gray-500 text-overflow max-sm:justify-center">{profile.foundername || "NA"}</p>
                    <p className="text-sm text-gray-600 mt-2 line-clamp-3">{profile.message || "NA"}</p>
                    <div className="profile-action space-x-3">
                      <button onClick={() => handleLike(profile.id)} className="flex items-center space-x-1 text-red-600 font-semibold">
                        {localStorage.getItem(`liked_${profile.id}`) ? (
                          <AiFillHeart className="text-xl" />
                        ) : (
                          <AiOutlineHeart className="text-xl" />
                        )}
                        <span>{formatNumber(profile.like)}</span>
                      </button>
                      <span className="flex items-center gap-1"><AiOutlineEye /> {formatNumber(profile.view)} Views</span>
                      <Link
                        to={`/profile/${(profile.companyname || "profile").replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}-${profile.id}`}
                        className="text-blue-600 hover:underline"
                      >
                        View Profile
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Ads */}
        <div className="ad-card-row">
           <a href="https://www.kalamsworldrecords.com" target="_blank" rel="noopener noreferrer">
          <img src={Adbanner} alt="Ads" />
          </a>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default Home;
